export enum Common {
  AUTHTOKEN = 'wtr/auth-token',
  CODE_LENGTH = 6,
  DEFAULT_LANGUAGE = 'en',
  REFERRAL_LINK = 'referral-link',
  APP_INFO_MODE = 'wtr/app-info-mode',
  MY = 'wtr/my',
  MAP_API_KEY = 'AIzaSyBa-CUURwJsMNnFoItf4WnslxQaRJDFbY0',
  WITHDRAWAL_IMAGE_CENT = 30000
}
